import { helper } from '@/utils'
import Logo from '../Logo/Logo.vue'
import Company from '../Company/Company.vue'

export default {
  name: 'Confirmation',
  components: { Company, Logo },
  computed: {
    isMobile: helper.isMobile
  },
  data () {
    return {
      appleStore: '',
      component: 'confirmation',
      footer: {},
      googlePlay: '',
      primaryColor: '#00BAFF',
      title: '',
      url: '',
      welcomeBody: ''
    }
  },
  methods: {
    getData () {
      return this.getTheme()
        .then(theme => {
          this.footer = {
            companyAddress: theme.company_address,
            companyContact: theme.company_contact,
            companyName: theme.company_name,
            companyUrl: theme.company_url
          }
          this.primaryColor = theme.primary_color
          this.googlePlay = theme.google_play
          this.appleStore = theme.apple_store
          this.url = theme.app_url_scheme + location.host
          this.title = this.getReplacedString('welcome_web_headline', theme)
          this.welcomeBody = this.getReplacedString('welcome_web_body', theme)
        })
        .then(() => {
          return this.activeUser(this.$route.params.token)
        })
        .catch((error) => {
          this.$router.push('/404')
          helper.showErrorMessage(this, this.component, error)
        })
    },
    getTheme () {
      return this.$api.getTheme()
        .then(({ body }) => body)
    },
    getReplacedString (key, theme) {
      return (theme[key] || '')
        .replace(/{{product_name}}/g, theme.product_name)
        .replace(/{{app_name}}/g, theme.app_name)
    },
    activeUser (token) {
      return this.$api.activeUser(token)
      .then(({ body }) => body)
    }
  },
  mounted () {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/pages/Confirmation/Confirmation.js